import { createContext } from "react";
import IBaseListingResponse from "../../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../../utils/helpers/constants";
import { IZoneQuery } from "../../../models/wms/zone/query";
import { IZone, IZoneDetails } from "../../../models/wms/zone/response";
import { ICreateZone, IUpdateZone } from "../../../models/wms/zone/request";

export type ZoneLoading =
  | "list"
  | "details"
  | "create"
  | "update"
  | "delete";

export interface IInternalState {
  loading: ZoneLoading[];
  list?: IBaseListingResponse<IZone>;
  query: IZoneQuery;
  details?: IZoneDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: IZoneDetails) => void;
    createZone: (request: ICreateZone) => void;
    updateZone: (id: number, request: IUpdateZone) => void;
    deleteZone: (id: number) => void;
    reorderZone: (id: number, pickSequence: number) => void;
    toggleZoneActive: (id: number, isActive: boolean) => void;
    setSearch: (search?: string) => void;
    setQuery: (query: IZoneQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    createZone: DEFAULT_FUNCTION,
    updateZone: DEFAULT_FUNCTION,
    deleteZone: DEFAULT_FUNCTION,
    reorderZone: DEFAULT_FUNCTION,
    toggleZoneActive: DEFAULT_FUNCTION,
    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const ZoneContext = createContext(externalState);
export default ZoneContext;
